import { Component } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import withComponentName from '../../../../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

class PricingFAQFooter extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  scrollToForm(e) {
    e.preventDefault();

    document.querySelector('#contactus-form').scrollIntoView({
      behavior: 'smooth',
    });
  }

  render() {
    const { hideForSmallDevices } = this.props;

    return (
      <div className={cx('PricingFAQ__footer', { 'hide-md': hideForSmallDevices })}>
        Have more questions? Need more answers?
        {' '}
        <br />
        Visit our
        {' '}
        <a href="/terms">
          Terms & Conditions page
        </a>
        {' '}
        or
        {' '}
        <a href="https://cityfalcon.zendesk.com/hc/en-us" target="_blank" rel="noopener noreferrer">
          Knowledge Base
        </a>
        {' '}
        or
        {' '}
        <a href="#contactus-form" onClick={this.scrollToForm}>
          contact us directly
        </a>
        .
      </div>
    );
  }
}

PricingFAQFooter.defaultProps = {
  hideForSmallDevices: false,
};

PricingFAQFooter.propTypes = {
  hideForSmallDevices: PropTypes.bool,
};

export default withComponentName(PricingFAQFooter);
